export default __webpack_public_path__ + "static/media/success.08f97146.svg";